<template>
  <div class="date-content">
    <div class="date-item">
      <van-datetime-picker
        v-model="currentDate"
        :title="params && params.title || ''"
        :type="type"
        @confirm="confirm"
        @cancel="cancel"
        :min-date="minDate"
      />
    </div>
  </div>
</template>

<script>
import { DatetimePicker } from 'vant'
export default {
  /**
   * 日期插件参数说明
   * params： {
   *     confirm: 确认回调 必传
   *     cancel:  取消回调 必传
   *     type:  插件类型 选传
   * }
   */
  name: 'date-time-plug',
  components: { DatetimePicker },
  props: ['params'],
  data () {
    return {
      currentDate: new Date(),
      type: this.params.type || 'date',
      minDate: this.params.minDate || new Date(1970, 0, 1)
    }
  },
  methods: {
    confirm () {
      this.$emit(this.params.confirm, this.currentDate)
    },
    cancel () {
      this.$emit(this.params.cancel)
    }
  }
}
</script>

<style lang="scss" scoped>
.date-content{
  position: fixed;
  border-bottom: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 99;
  background: rgba(000, 000, 000, 0.3);
  .date-item{
    position: absolute;
    bottom: 0;
    width: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/datetime.vue